import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ANUENCIA.ASSINATURA.ASSINAR]({ commit }, idEmailAdesaoFornec) {
		let { data } = await api.assinaturaAnuencia.assinar(idEmailAdesaoFornec)
		return data
	},
}
